import { axiosInstanceIMG } from './axio-instance';

/**
 * Build a full, servable image URL at render time from a stored value.
 *
 * Profile/gallery images are stored as an API-relative path only, e.g.
 *   /images/download/9979168795/profile/full/1784719816292.webp
 * The image-api host is NOT stored — it's taken from the configured image-api
 * base (axiosInstanceIMG, from REACT_APP_IMAGE_API_URL) so the same record
 * resolves correctly across environments.
 *
 * Legacy absolute URLs (e.g. social-login avatars) are returned unchanged.
 */
export const buildImageUrl = (path) => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  const base = axiosInstanceIMG.defaults.baseURL || process.env.REACT_APP_IMAGE_API_URL || '';
  return `${base}${path.startsWith('/') ? '' : '/'}${path}`;
};

/** Relative API path stored for an image key returned by images-api. */
export const imagePathForKey = (key) => `/images/download/${key}`;
